import React from "react";

const steps = [
  { t1: "Schritt 1", t2: "Anfragen", p: "Senden Sie uns Termin, Start/Ziel, Stockwerk, Aufzug." },
  { t1: "Schritt 2", t2: "Angebot erhalten", p: "Sie bekommen ein transparentes Festpreis-Angebot." },
  { t1: "Schritt 3", t2: "Stressfrei umziehen", p: "Wir übernehmen Be-/Entladen, Transport & Montage." },
];

export default function Steps() {
  return (
    <section id="ablauf" className="py-12 md:py-16 bg-white">
      <div className="max-w-[1100px] mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold">In 3 Schritten zum Umzug</h2>
        <div className="mt-6 grid md:grid-cols-3 gap-6">
          {steps.map((s) => (
            <div key={s.t2} className="rounded-2xl p-6 shadow-[0_10px_25px_rgba(2,6,23,.06)]">
              <div className="text-sm opacity-70">{s.t1}</div>
              <div className="mt-2 font-semibold text-lg">{s.t2}</div>
              <p className="mt-2 text-slate-600 text-sm">{s.p}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
